import { Element } from '@prismicio/react';
import Image from 'next/image';
import { ButtonInline } from 'remote-com-shared/components/Button';

import { ListItem, Heading3, ImageContainer } from './styled';

/**
 * @deprecated For backwards compatibility, though `defaultPrismicComponents` is preferred
 */
export function defaultHtmlSerializer(type, element, text, children, key) {
  switch (type) {
    case Element.hyperlink: {
      const { url, target } = element.data;
      return <Hyperlink {...{ url, target, key, children }} />;
    }
    case Element.listItem: {
      return <ListItem key={key}>{children}</ListItem>;
    }
    default:
      return null;
  }
}

/**
 * To use components directly, which is preferred
 */

export const defaultPrismicComponents = {
  hyperlink: ({
    node: {
      data: { url, target },
    },
    children,
  }) => <Hyperlink {...{ url, target, children }} />,
  listItem: ({ children }) => <ListItem>{children}</ListItem>,
  heading3: ({ children }) => <Heading3>{children}</Heading3>,
  image: ({ node }) => {
    const { url, alt, dimensions } = node;
    return (
      <ImageContainer>
        <Image src={url} {...dimensions} alt={alt || ''} quality="100" />
      </ImageContainer>
    );
  },
};

/**
 * To extend existing Components, e.g. when a custom style/prop needs to be passed
 */
export const Hyperlink = ({ url, children, ...props }) => (
  <ButtonInline {...props} href={url}>
    {children}
  </ButtonInline>
);
